import { apiService } from '.';
import { TOKEN } from '../contexts/authContext';
import { wspTemplate } from '../shared/types/wspTemplate';

export const asyncPostLoadBase = (
    formdata: any,
    list: string,
    loadOnlyInDB: boolean,
    deleteAndSave: boolean
) => {
    return apiService.post(
        '/api/commercial-crm',
        formdata,
        {
            list,
            loadOnlyInDB: loadOnlyInDB ? '1' : '0',
            deleteAndSave: deleteAndSave ? '1' : '0',
        },
        {
            accept: '*/*',
            Authorization: 'Bearer ' + sessionStorage.getItem(TOKEN),
        }
    );
};

export const asyncGetLists = async (): Promise<{ items: string[] }> => {
    return await apiService.get('/api/commercial-crm/lists');
};

export const asyncGetTemplates = async (): Promise<{
    items: { id: string; description: string }[];
}> => {
    return await apiService.get('/api/stop-scrubbing/templates');
};

export const asyncPatchTemplate = async (id: string, formSurvey: any) => {
    return await apiService.put(
        `/api/stop-scrubbing/template/${id}`,
        formSurvey
    );
};

export const asyncPostTemplate = async (formTemplate: wspTemplate) => {
    return await apiService.post(
        '/api/stop-scrubbing/save-template',
        formTemplate
    );
};

export const asyncGetTemplateList = async (
    page?: number,
    pageSize?: number
) => {
    return await apiService.get('/api/stop-scrubbing/list-templates', {
        limit: pageSize || '',
        page: page || '',
    });
};

export const asyncGetTemplateId = async (
    id: string | undefined,
    active?: boolean | undefined
) => {
    return await apiService.get(
        `/api/stop-scrubbing/${id}`,
        active ? { active } : undefined
    );
};

export const asyncPostLoadBaseGupshup = (formdata: any, template: string) => {
    return apiService.post(
        '/api/stop-scrubbing/load-base',
        formdata,
        { template },
        {
            accept: '*/*',
            Authorization: 'Bearer ' + sessionStorage.getItem(TOKEN),
        }
    );
};

export const asyncPauseSending = async (scenery: string) => {
    return apiService.post(
        `/api/stop-scrubbing/pause-sending/${scenery}`,
        {},
        {},
        {
            Authorization: 'Bearer ' + sessionStorage.getItem(TOKEN),
        }
    );
};

export const asyncReactivateSending = async (scenery: string) => {
    return apiService.post(
        `/api/stop-scrubbing/reactivate-sending/${scenery}`,
        {},
        {},
        {
            Authorization: 'Bearer ' + sessionStorage.getItem(TOKEN),
        }
    );
};
